export * from '@platform/components/loading-bar/public-api';
